// // // dashboard-frontend/src/components/AdminCashDonations.jsx
// import React, { useState, useEffect } from 'react';
// import DataTable from 'react-data-table-component';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { CSVLink } from 'react-csv';
// import { fetchJSON } from '../api';
// import { Line } from 'react-chartjs-2';
// import 'chart.js/auto';

// const AdminCashDonations = (props) => {
//   const [cashDonations, setCashDonations] = useState([]);
//   const [volunteers, setVolunteers] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Filters
//   const [filterStatus, setFilterStatus] = useState('');
//   const [selectedVolunteerId, setSelectedVolunteerId] = useState('');
//   const [volunteerNameFilter, setVolunteerNameFilter] = useState('');
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [filteredDonations, setFilteredDonations] = useState([]);

//   // Chart data
//   const [chartData, setChartData] = useState({});

//   // Current admin user
//   const adminUser = JSON.parse(localStorage.getItem('dashboardUser') || '{}');

//   // 1) Fetch data
//   const fetchCashDonations = async () => {
//     try {
//       const donationsData = await fetchJSON('/api/users/cash-donations');
//       setCashDonations(donationsData);

//       const volunteersData = await fetchJSON('/api/users?role=volunteer');
//       setVolunteers(volunteersData);
//     } catch (err) {
//       console.error('Error fetching data:', err);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchCashDonations();
//   }, []);

//   // 2) Summaries (unfiltered)
//   const activeDonations = cashDonations.filter(d => !d.isDeleted);
//   const donationsCash = activeDonations.filter(d => d.donationType === 'cash');
//   const donationsCheque = activeDonations.filter(d => d.donationType === 'cheque');
//   const donationsUPI = activeDonations.filter(d => d.donationType === 'upi');

//   const totalCash = donationsCash.reduce((sum, d) => sum + Number(d.amount), 0);
//   const totalCheque = donationsCheque.reduce((sum, d) => sum + Number(d.amount), 0);
//   const totalUPI = donationsUPI.reduce((sum, d) => sum + Number(d.amount), 0);

//   // 3) Filter logic
//   useEffect(() => {
//     let temp = [...cashDonations];

//     // Filter by status
//     if (filterStatus) {
//       temp = temp.filter(d => d.status === filterStatus);
//     }

//     // Filter by date range
//     temp = temp.filter(donation => {
//       const dt = new Date(donation.createdAt);
//       if (startDate && dt < startOfDay(startDate)) return false;
//       if (endDate && dt > endOfDay(endDate)) return false;
//       return true;
//     });

//     // Free-text volunteer name
//     if (volunteerNameFilter.trim()) {
//       const lower = volunteerNameFilter.toLowerCase();
//       temp = temp.filter(d => d.volunteer?.username?.toLowerCase().includes(lower));
//     }

//     // Volunteer dropdown
//     if (selectedVolunteerId) {
//       temp = temp.filter(d => d.volunteer && d.volunteer._id === selectedVolunteerId);
//     }

//     setFilteredDonations(temp);
//   }, [cashDonations, filterStatus, startDate, endDate, volunteerNameFilter, selectedVolunteerId]);

//   // Helpers for start/end of day
//   const startOfDay = (date) => {
//     const d = new Date(date);
//     d.setHours(0, 0, 0, 0);
//     return d;
//   };
//   const endOfDay = (date) => {
//     const d = new Date(date);
//     d.setHours(23, 59, 59, 999);
//     return d;
//   };

//   // 4) Chart data (7-day)
//   useEffect(() => {
//     const now = new Date();
//     const sevenDaysAgo = new Date(now);
//     sevenDaysAgo.setDate(now.getDate() - 6);

//     const active = cashDonations.filter(d => !d.isDeleted);
//     const recentDonations = active.filter(d => {
//       const dt = new Date(d.createdAt);
//       return dt >= sevenDaysAgo && dt <= now;
//     });

//     const groups = {};
//     recentDonations.forEach(d => {
//       const day = new Date(d.createdAt).toISOString().split('T')[0];
//       if (!groups[day]) groups[day] = 0;
//       groups[day] += Number(d.amount);
//     });

//     const labels = [];
//     const dataPoints = [];
//     for (let i = 0; i < 7; i++) {
//       const date = new Date(sevenDaysAgo);
//       date.setDate(sevenDaysAgo.getDate() + i);
//       const key = date.toISOString().split('T')[0];
//       labels.push(key);
//       dataPoints.push(groups[key] || 0);
//     }

//     setChartData({
//       labels,
//       datasets: [
//         {
//           label: 'Cash Donations (INR)',
//           data: dataPoints,
//           borderColor: '#792a21',
//           backgroundColor: 'rgba(121,42,33,0.2)',
//           fill: true,
//         },
//       ],
//     });
//   }, [cashDonations]);

//   // 5) Summaries for filtered
//   const totalFilteredAmount = filteredDonations.reduce((sum, d) => sum + Number(d.amount), 0);
//   const totalFilteredDeposited = filteredDonations
//     .filter(d => d.depositAcknowledged)
//     .reduce((sum, d) => sum + Number(d.amount), 0);
//   const totalFilteredPending = totalFilteredAmount - totalFilteredDeposited;

//   // 6) Verify & Delete
//   const handleVerifyDeposit = async (donationId) => {
//     try {
//       await fetchJSON(`/api/users/cash-donation/${donationId}/verify-deposit`, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//       });
//       alert("Deposit verified successfully");
//       fetchCashDonations();
//     } catch (error) {
//       console.error("Error verifying deposit:", error);
//       alert(error.message || "Failed to verify deposit");
//     }
//   };

//   const handleSoftDelete = async (donationId) => {
//     if (!window.confirm("Are you sure you want to delete this transaction?")) return;
//     try {
//       await fetchJSON(`/api/users/cash-donation/${donationId}/delete`, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//       });
//       alert("Donation soft-deleted successfully");
//       fetchCashDonations();
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   // NEW: Preview receipt for offline donation
//   const handlePreviewReceipt = (donationId, donationType) => {
//     // Example: navigate to /admin/receipt-preview
//     window.location.href = `/admin/receipt-preview?id=${donationId}&type=${donationType}`;
//   };

//   // 7) DataTable
//   const customStyles = {
//     rows: {
//       style: {
//         minHeight: '60px',
//       },
//     },
//     headCells: {
//       style: {
//         fontSize: '14px',
//         fontWeight: 'bold',
//         paddingLeft: '8px',
//         paddingRight: '8px',
//       },
//     },
//     cells: {
//       style: {
//         paddingLeft: '8px',
//         paddingRight: '8px',
//         whiteSpace: 'normal',
//         wordBreak: 'break-word',
//         fontSize: '14px',
//       },
//     },
//   };

//   const conditionalRowStyles = [
//     {
//       when: row => row.isDeleted,
//       style: {
//         textDecoration: "line-through",
//         opacity: 0.6,
//         backgroundColor: "#f5f5f5",
//       },
//     },
//   ];

//   const ExpandedRow = ({ data }) => (
//     <div className="p-4 bg-gray-50">
//       <p><strong>Volunteer:</strong> {data.volunteer?.username || 'N/A'}</p>
//       <p><strong>Donor Name:</strong> {data.name}</p>
//       <p><strong>Phone:</strong> {data.phone}</p>
//       <p><strong>Email:</strong> {data.email}</p>
//       <p><strong>City:</strong> {data.city || '-'}</p>
//       <p><strong>Aadhar:</strong> {data.aadharCard || '-'}</p>
//       <p><strong>PAN:</strong> {data.panCard || '-'}</p>
//       <p><strong>Receipt Number:</strong> {data.receiptNumber || '-'}</p>
//       <p><strong>Amount:</strong> {data.amount}</p>
//       <p><strong>Note:</strong> {data.note}</p>
//       <p><strong>Donation Type:</strong> {data.donationType}</p>
//       <p><strong>Bank Name:</strong> {data.bankName || '-'}</p>
//       <p><strong>Cheque Number:</strong> {data.chequeNumber || '-'}</p>
//       <p><strong>UPI Txn ID:</strong> {data.upiTransactionId || '-'}</p>
//       <p><strong>Status:</strong> {data.status}</p>
//       <p><strong>Collected At:</strong> {new Date(data.createdAt).toLocaleString()}</p>
//       <p><strong>Deposit Note:</strong> {data.depositNote || '-'}</p>
//       <p><strong>Deposit Verified:</strong> {data.depositVerified ? "Yes" : "No"}</p>
//       <p><strong>Verified At:</strong> {data.depositVerifiedAt ? new Date(data.depositVerifiedAt).toLocaleString() : '-'}</p>
//     </div>
//   );

//   const truncateText = (text, limit = 40) => {
//     if (!text) return '';
//     return text.length > limit ? `${text.substring(0, limit)}...` : text;
//   };

//   const columns = [
//     {
//       name: 'Volunteer',
//       selector: row => row.volunteer?.username || 'N/A',
//       sortable: true,
//       minWidth: '120px',
//       wrap: true,
//     },
//     {
//       name: 'Donor Name',
//       selector: row => row.name,
//       sortable: true,
//       minWidth: '150px',
//       wrap: true,
//     },
//     {
//       name: 'Phone',
//       selector: row => row.phone,
//       sortable: true,
//       minWidth: '120px',
//     },
//     {
//       name: 'Email',
//       selector: row => row.email,
//       minWidth: '200px',
//       wrap: true,
//     },
//     {
//       name: 'Amount',
//       selector: row => row.amount,
//       sortable: true,
//       minWidth: '100px',
//     },
//     {
//       name: 'Note',
//       selector: row => truncateText(row.note),
//       cell: row => <span title={row.note}>{truncateText(row.note)}</span>,
//       minWidth: '200px',
//       wrap: true,
//     },
//     {
//       name: 'Donation Type',
//       selector: row => row.donationType,
//       sortable: true,
//       minWidth: '120px',
//     },
//     {
//       name: 'Bank Name',
//       selector: row => row.bankName || '-',
//       sortable: true,
//       minWidth: '120px',
//       wrap: true,
//     },
//     {
//       name: 'Cheque Number',
//       selector: row => row.chequeNumber || '-',
//       sortable: true,
//       minWidth: '120px',
//       wrap: true,
//     },
//     {
//       name: 'Status',
//       selector: row => row.status,
//       sortable: true,
//       minWidth: '100px',
//     },
//     {
//       name: 'Collected At',
//       selector: row => new Date(row.createdAt).toLocaleString(),
//       sortable: true,
//       minWidth: '160px',
//       wrap: true,
//     },
//     {
//       name: 'Deposit Note',
//       selector: row => row.depositNote || '-',
//       minWidth: '150px',
//       wrap: true,
//     },
//     {
//       name: 'Deposit Verified',
//       selector: row => row.depositVerified ? "Yes" : "No",
//       sortable: true,
//       minWidth: '120px',
//     },
//     {
//       name: 'Verified At',
//       selector: row => row.depositVerifiedAt ? new Date(row.depositVerifiedAt).toLocaleString() : '-',
//       minWidth: '160px',
//       wrap: true,
//     },
//     {
//       name: 'Action',
//       cell: row => {
//         const canVerify =
//           row.depositAcknowledged &&
//           !row.depositVerified &&
//           (adminUser.role === "master_admin" || adminUser.role === "accounts") &&
//           !props.readOnly;

//         const canDelete =
//           !row.isDeleted &&
//           (adminUser.role === 'master_admin' || adminUser.role === 'admin');

//         return (
//           <div className="flex space-x-2">
//             {/* PREVIEW BUTTON for offline receipt */}
//             <button
//               onClick={() => handlePreviewReceipt(row._id, row.donationType)}
//               className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded"
//             >
//               Preview
//             </button>

//             {canVerify && (
//               <button
//                 onClick={() => handleVerifyDeposit(row._id)}
//                 className="bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded"
//               >
//                 Verify
//               </button>
//             )}
//             {canDelete && (
//               <button
//                 onClick={() => handleSoftDelete(row._id)}
//                 className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded"
//               >
//                 Delete
//               </button>
//             )}
//           </div>
//         );
//       },
//       ignoreRowClick: true,
//       allowOverflow: true,
//       button: true,
//       minWidth: '220px',
//     },
//   ];

//   // CSV config
//   const csvHeaders = [
//     { label: 'Volunteer', key: 'volunteer.username' },
//     { label: 'Donor Name', key: 'name' },
//     { label: 'Phone', key: 'phone' },
//     { label: 'Email', key: 'email' },
//     { label: 'City', key: 'city' },
//     { label: 'Aadhar Card', key: 'aadharCard' },
//     { label: 'PAN Card', key: 'panCard' },
//     { label: 'Receipt Number', key: 'receiptNumber' },
//     { label: 'Amount', key: 'amount' },
//     { label: 'Note', key: 'note' },
//     { label: 'Donation Type', key: 'donationType' },
//     { label: 'Bank Name', key: 'bankName' },
//     { label: 'Cheque Number', key: 'chequeNumber' },
//     { label: 'Status', key: 'status' },
//     { label: 'Collected At', key: 'createdAt' },
//     { label: 'Deposit Note', key: 'depositNote' },
//     { label: 'Deposit Verified', key: 'depositVerified' },
//     { label: 'Verified At', key: 'depositVerifiedAt' },
//   ];

//   // Quick preset filters
//   const setPreset = (preset) => {
//     const now = new Date();
//     switch (preset) {
//       case 'today':
//         setStartDate(startOfDay(now));
//         setEndDate(endOfDay(now));
//         break;
//       case 'thisWeek': {
//         const day = now.getDay(); 
//         const diffToMonday = day === 0 ? 6 : day - 1;
//         const monday = new Date(now);
//         monday.setDate(now.getDate() - diffToMonday);
//         setStartDate(startOfDay(monday));
//         const sunday = new Date(monday);
//         sunday.setDate(monday.getDate() + 6);
//         setEndDate(endOfDay(sunday));
//         break;
//       }
//       case 'thisMonth': {
//         const first = new Date(now.getFullYear(), now.getMonth(), 1);
//         const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
//         setStartDate(startOfDay(first));
//         setEndDate(endOfDay(last));
//         break;
//       }
//       case 'thisYear': {
//         const firstOfYear = new Date(now.getFullYear(), 0, 1);
//         const lastOfYear = new Date(now.getFullYear(), 11, 31);
//         setStartDate(startOfDay(firstOfYear));
//         setEndDate(endOfDay(lastOfYear));
//         break;
//       }
//       case 'financialYear': {
//         let fyStart;
//         let fyEnd;
//         if (now.getMonth() >= 3) {
//           fyStart = new Date(now.getFullYear(), 3, 1);
//           fyEnd = new Date(now.getFullYear() + 1, 2, 31);
//         } else {
//           fyStart = new Date(now.getFullYear() - 1, 3, 1);
//           fyEnd = new Date(now.getFullYear(), 2, 31);
//         }
//         setStartDate(startOfDay(fyStart));
//         setEndDate(endOfDay(fyEnd));
//         break;
//       }
//       default:
//         setStartDate(null);
//         setEndDate(null);
//     }
//   };

//   return (
//     <div className="p-4">
//       <h2 className="text-2xl font-bold mb-4">Cash/Cheque/UPI Donations</h2>

//       {/* Overall Summaries */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
//         <div className="p-6 bg-white rounded shadow">
//           <h3 className="text-xl font-semibold">Cash</h3>
//           <p>Transactions: {donationsCash.length}</p>
//           <p>Total Amount: ₹{totalCash}</p>
//         </div>
//         <div className="p-6 bg-white rounded shadow">
//           <h3 className="text-xl font-semibold">Cheque</h3>
//           <p>Transactions: {donationsCheque.length}</p>
//           <p>Total Amount: ₹{totalCheque}</p>
//         </div>
//         <div className="p-6 bg-white rounded shadow">
//           <h3 className="text-xl font-semibold">UPI</h3>
//           <p>Transactions: {donationsUPI.length}</p>
//           <p>Total Amount: ₹{totalUPI}</p>
//         </div>
//       </div>

//       {/* Trend Chart */}
//       <div className="bg-white p-6 rounded shadow mb-6">
//         <h3 className="text-xl font-semibold mb-4">Donation Trends (Last 7 Days)</h3>
//         {chartData.labels && chartData.labels.length > 0 ? (
//           <div className="h-64">
//             <Line
//               data={chartData}
//               options={{ responsive: true, maintainAspectRatio: false }}
//             />
//           </div>
//         ) : (
//           <p>No trend data available.</p>
//         )}
//       </div>

//       {/* Filter Controls */}
//       <div className="mb-4 flex flex-wrap items-center gap-4">

//         {/* Status Filter */}
//         <div className="flex flex-col">
//           <label className="mb-1">Status Filter:</label>
//           <select
//             value={filterStatus}
//             onChange={e => setFilterStatus(e.target.value)}
//             className="border p-1 rounded"
//           >
//             <option value="">All</option>
//             <option value="collected">Collected</option>
//           </select>
//         </div>

//         {/* Volunteer Dropdown */}
//         <div className="flex flex-col">
//           <label className="mb-1">Filter by Volunteer:</label>
//           <select
//             value={selectedVolunteerId}
//             onChange={e => setSelectedVolunteerId(e.target.value)}
//             className="border p-1 rounded"
//           >
//             <option value="">All Volunteers</option>
//             {volunteers.map(vol => (
//               <option key={vol._id} value={vol._id}>
//                 {vol.username}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Name (text) Filter */}
//         <div className="flex flex-col">
//           <label className="mb-1">Volunteer Name (text):</label>
//           <input
//             type="text"
//             value={volunteerNameFilter}
//             onChange={e => setVolunteerNameFilter(e.target.value)}
//             placeholder="Search volunteer..."
//             className="border p-1 rounded"
//           />
//         </div>

//         {/* Date Range */}
//         <div className="flex flex-col">
//           <label className="mb-1">Start Date:</label>
//           <DatePicker
//             selected={startDate}
//             onChange={date => setStartDate(date)}
//             dateFormat="yyyy-MM-dd"
//             placeholderText="Select start date"
//             className="border p-1 rounded"
//           />
//         </div>
//         <div className="flex flex-col">
//           <label className="mb-1">End Date:</label>
//           <DatePicker
//             selected={endDate}
//             onChange={date => setEndDate(date)}
//             dateFormat="yyyy-MM-dd"
//             placeholderText="Select end date"
//             className="border p-1 rounded"
//           />
//         </div>

//         {/* Quick Preset Buttons */}
//         <div className="flex flex-wrap gap-1">
//           <button
//             onClick={() => setPreset('today')}
//             className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
//           >
//             Today
//           </button>
//           <button
//             onClick={() => setPreset('thisWeek')}
//             className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
//           >
//             This Week
//           </button>
//           <button
//             onClick={() => setPreset('thisMonth')}
//             className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
//           >
//             This Month
//           </button>
//           <button
//             onClick={() => setPreset('thisYear')}
//             className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
//           >
//             This Year
//           </button>
//           <button
//             onClick={() => setPreset('financialYear')}
//             className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
//           >
//             Fin. Year
//           </button>
//           <button
//             onClick={() => setPreset(null)}
//             className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
//           >
//             Clear
//           </button>
//         </div>

//         {/* CSV Export */}
//         <div className="flex flex-col justify-end">
//           <CSVLink
//             data={filteredDonations}
//             headers={csvHeaders}
//             filename={`cash-cheque-donations-${Date.now()}.csv`}
//             className="px-4 py-2 bg-primary text-white rounded"
//           >
//             Export CSV
//           </CSVLink>
//         </div>
//       </div>

//       {/* Data Table */}
//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <>
//           <DataTable
//             columns={columns}
//             data={filteredDonations}
//             pagination
//             defaultSortField="createdAt"
//             responsive
//             customStyles={customStyles}
//             expandableRows
//             expandableRowsComponent={ExpandedRow}
//             conditionalRowStyles={conditionalRowStyles}
//           />

//           {/* Summation of filtered donations */}
//           <div className="mt-4 p-4 bg-white rounded shadow">
//             <h3 className="text-lg font-bold mb-2">Filtered Summary</h3>
//             <p>Total Filtered Amount: <strong>₹{totalFilteredAmount}</strong></p>
//             <p>Deposited (Acknowledged): <strong>₹{totalFilteredDeposited}</strong></p>
//             <p>Pending Deposit: <strong>₹{totalFilteredPending}</strong></p>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default AdminCashDonations;


import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CSVLink } from 'react-csv';
import { fetchJSON, submitCashDonation } from '../api';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

const AdminCashDonations = (props) => {
  const [cashDonations, setCashDonations] = useState([]);
  const [volunteers, setVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Replacing status filter with depositVerified filter
  // '' => All, 'yes' => depositVerified===true, 'no' => depositVerified===false
  const [filterDepositVerified, setFilterDepositVerified] = useState('');
  const [selectedVolunteerId, setSelectedVolunteerId] = useState('');
  const [volunteerNameFilter, setVolunteerNameFilter] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [filteredDonations, setFilteredDonations] = useState([]);

  // Chart data
  const [chartData, setChartData] = useState({});

  // Current admin user
  const adminUser = JSON.parse(localStorage.getItem('dashboardUser') || '{}');

  // 1) Fetch data
  const fetchCashDonations = async () => {
    try {
      const donationsData = await fetchJSON('/api/users/cash-donations');
      setCashDonations(donationsData);

      const volunteersData = await fetchJSON('/api/users?role=volunteer');
      setVolunteers(volunteersData);
    } catch (err) {
      console.error('Error fetching data:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCashDonations();
  }, []);

  // 2) Summaries (unfiltered)
  const activeDonations = cashDonations.filter(d => !d.isDeleted);
  const donationsCash = activeDonations.filter(d => d.donationType === 'cash');
  const donationsCheque = activeDonations.filter(d => d.donationType === 'cheque');
  const donationsUPI = activeDonations.filter(d => d.donationType === 'upi');

  const totalCash = donationsCash.reduce((sum, d) => sum + Number(d.amount), 0);
  const totalCheque = donationsCheque.reduce((sum, d) => sum + Number(d.amount), 0);
  const totalUPI = donationsUPI.reduce((sum, d) => sum + Number(d.amount), 0);

  // 3) Filter logic
  useEffect(() => {
    let temp = [...cashDonations];

    // Filter by depositVerified
    if (filterDepositVerified === 'yes') {
      temp = temp.filter(d => d.depositVerified === true);
    } else if (filterDepositVerified === 'no') {
      temp = temp.filter(d => d.depositVerified === false);
    }
    // else if filterDepositVerified === '', do nothing => show all

    // Filter by date range
    temp = temp.filter(donation => {
      const dt = new Date(donation.createdAt);
      if (startDate && dt < startOfDay(startDate)) return false;
      if (endDate && dt > endOfDay(endDate)) return false;
      return true;
    });

    // Free-text volunteer name
    if (volunteerNameFilter.trim()) {
      const lower = volunteerNameFilter.toLowerCase();
      temp = temp.filter(d =>
        d.volunteer?.username?.toLowerCase().includes(lower)
      );
    }

    // Volunteer dropdown
    if (selectedVolunteerId) {
      temp = temp.filter(d => d.volunteer && d.volunteer._id === selectedVolunteerId);
    }

    setFilteredDonations(temp);
  }, [
    cashDonations,
    filterDepositVerified,
    startDate,
    endDate,
    volunteerNameFilter,
    selectedVolunteerId
  ]);

  // Helpers for start/end of day
  const startOfDay = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  const endOfDay = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  };

  // 4) Chart data (7-day)
  useEffect(() => {
    const now = new Date();
    const sevenDaysAgo = new Date(now);
    sevenDaysAgo.setDate(now.getDate() - 6);

    const active = cashDonations.filter(d => !d.isDeleted);
    const recentDonations = active.filter(d => {
      const dt = new Date(d.createdAt);
      return dt >= sevenDaysAgo && dt <= now;
    });

    const groups = {};
    recentDonations.forEach(d => {
      const day = new Date(d.createdAt).toISOString().split('T')[0];
      if (!groups[day]) groups[day] = 0;
      groups[day] += Number(d.amount);
    });

    const labels = [];
    const dataPoints = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(sevenDaysAgo);
      date.setDate(sevenDaysAgo.getDate() + i);
      const key = date.toISOString().split('T')[0];
      labels.push(key);
      dataPoints.push(groups[key] || 0);
    }

    setChartData({
      labels,
      datasets: [
        {
          label: 'Cash Donations (INR)',
          data: dataPoints,
          borderColor: '#792a21',
          backgroundColor: 'rgba(121,42,33,0.2)',
          fill: true,
        },
      ],
    });
  }, [cashDonations]);

  // 5) Summaries for filtered
  const totalFilteredAmount = filteredDonations.reduce((sum, d) => sum + Number(d.amount), 0);
  const totalFilteredDeposited = filteredDonations
    .filter(d => d.depositAcknowledged)
    .reduce((sum, d) => sum + Number(d.amount), 0);
  const totalFilteredPending = totalFilteredAmount - totalFilteredDeposited;

  // 6) Verify & Delete
  const handleVerifyDeposit = async (donationId) => {
    try {
      await fetchJSON(`/api/users/cash-donation/${donationId}/verify-deposit`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
      });
      alert("Deposit verified successfully");
      fetchCashDonations();
    } catch (error) {
      console.error("Error verifying deposit:", error);
      alert(error.message || "Failed to verify deposit");
    }
  };

  const handleSoftDelete = async (donationId) => {
    if (!window.confirm("Are you sure you want to delete this transaction?")) return;
    try {
      await fetchJSON(`/api/users/cash-donation/${donationId}/delete`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
      });
      alert("Donation soft-deleted successfully");
      fetchCashDonations();
    } catch (err) {
      alert(err.message);
    }
  };

  // NEW: Preview receipt
  const handlePreviewReceipt = (donationId, donationType) => {
    // navigate to /admin/receipt-preview
    window.location.href = `/admin/receipt-preview?id=${donationId}&type=${donationType}`;
  };

  // 7) DataTable
  const customStyles = {
    rows: {
      style: {
        minHeight: '60px',
      },
    },
    headCells: {
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        fontSize: '14px',
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: row => row.isDeleted,
      style: {
        textDecoration: "line-through",
        opacity: 0.6,
        backgroundColor: "#f5f5f5",
      },
    },
  ];

  // Expanded row (all fields)
  const ExpandedRow = ({ data }) => (
    <div className="p-4 bg-gray-50">
      {/* Show everything including email, bankName, chequeNumber */}
      <p><strong>Receipt Number:</strong> {data.receiptNumber || '-'}</p>
      <p><strong>Donor Name:</strong> {data.name}</p>
      <p><strong>Phone:</strong> {data.phone}</p>
      <p><strong>Email:</strong> {data.email}</p>
      <p><strong>City:</strong> {data.city || '-'}</p>
      <p><strong>Aadhar:</strong> {data.aadharCard || '-'}</p>
      <p><strong>PAN:</strong> {data.panCard || '-'}</p>
      <p><strong>Amount:</strong> {data.amount}</p>
      <p><strong>Note:</strong> {data.note}</p>
      <p><strong>Donation Type:</strong> {data.donationType}</p>
      <p><strong>Bank Name:</strong> {data.bankName || '-'}</p>
      <p><strong>Cheque Number:</strong> {data.chequeNumber || '-'}</p>
      <p><strong>UPI Txn ID:</strong> {data.upiTransactionId || '-'}</p>
      <p><strong>Volunteer (username):</strong> {data.volunteer?.username || 'N/A'}</p>
      <p><strong>Status:</strong> {data.status}</p>
      <p><strong>Collected At:</strong> {new Date(data.createdAt).toLocaleString()}</p>
      <p><strong>Deposit Note:</strong> {data.depositNote || '-'}</p>
      <p><strong>Deposit Verified:</strong> {data.depositVerified ? "Yes" : "No"}</p>
      <p><strong>Verified At:</strong> {data.depositVerifiedAt ? new Date(data.depositVerifiedAt).toLocaleString() : '-'}</p>
    </div>
  );

  // For long text
  const truncateText = (text, limit = 40) => {
    if (!text) return '';
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  };

  // Reordered columns:
  //  1) receiptNumber
  //  2) name
  //  3) phone
  //  4) amount
  //  5) note
  //  6) city
  //  7) donationType
  //  8) volunteer?.username
  //  9) status
  // 10) createdAt
  // 11) depositNote
  // 12) depositVerified
  // 13) verifiedAt
  // 14) action
  const columns = [
    {
      name: 'Receipt No.',
      selector: row => row.receiptNumber || '-',
      sortable: true,
      minWidth: '130px',
      wrap: true,
    },
    {
      name: 'Donor Name',
      selector: row => row.name,
      sortable: true,
      minWidth: '150px',
      wrap: true,
    },
    {
      name: 'Phone',
      selector: row => row.phone,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Amount',
      selector: row => row.amount,
      sortable: true,
      minWidth: '100px',
    },
    {
      name: 'Note',
      selector: row => truncateText(row.note),
      cell: row => <span title={row.note}>{truncateText(row.note)}</span>,
      minWidth: '150px',
      wrap: true,
    },
    {
      name: 'City',
      selector: row => row.city || '-',
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Donation Type',
      selector: row => row.donationType,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Volunteer',
      selector: row => row.volunteer?.username || 'N/A',
      sortable: true,
      minWidth: '120px',
      wrap: true,
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      minWidth: '100px',
    },
    {
      name: 'Collected At',
      selector: row => new Date(row.createdAt).toLocaleString(),
      sortable: true,
      minWidth: '160px',
      wrap: true,
    },
    {
      name: 'Deposit Note',
      selector: row => row.depositNote || '-',
      minWidth: '150px',
      wrap: true,
    },
    {
      name: 'Deposit Verified',
      selector: row => row.depositVerified ? "Yes" : "No",
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Verified At',
      selector: row => row.depositVerifiedAt ? new Date(row.depositVerifiedAt).toLocaleString() : '-',
      minWidth: '160px',
      wrap: true,
    },
    {
      name: 'Action',
      cell: row => {
        const canVerify =
          row.depositAcknowledged &&
          !row.depositVerified &&
          (adminUser.role === "master_admin" || adminUser.role === "accounts") &&
          !props.readOnly;

        const canDelete =
          !row.isDeleted &&
          (adminUser.role === 'master_admin' || adminUser.role === 'admin');

        return (
          <div className="flex space-x-2">
            {/* PREVIEW BUTTON */}
            <button
              onClick={() => handlePreviewReceipt(row._id, row.donationType)}
              className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded"
            >
              Preview
            </button>

            {canVerify && (
              <button
                onClick={() => handleVerifyDeposit(row._id)}
                className="bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded"
              >
                Verify
              </button>
            )}
            {canDelete && (
              <button
                onClick={() => handleSoftDelete(row._id)}
                className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded"
              >
                Delete
              </button>
            )}
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: '220px',
    },
  ];

  // CSV config (including everything you want, e.g. email, bankName, etc.)
  const csvHeaders = [
    { label: 'Receipt Number', key: 'receiptNumber' },
    { label: 'Donor Name', key: 'name' },
    { label: 'Phone', key: 'phone' },
    { label: 'Email', key: 'email' },
    { label: 'City', key: 'city' },
    { label: 'Aadhar Card', key: 'aadharCard' },
    { label: 'PAN Card', key: 'panCard' },
    { label: 'Amount', key: 'amount' },
    { label: 'Note', key: 'note' },
    { label: 'Donation Type', key: 'donationType' },
    { label: 'Bank Name', key: 'bankName' },
    { label: 'Cheque Number', key: 'chequeNumber' },
    { label: 'Volunteer', key: 'volunteer.username' },
    { label: 'Status', key: 'status' },
    { label: 'Collected At', key: 'createdAt' },
    { label: 'Deposit Note', key: 'depositNote' },
    { label: 'Deposit Verified', key: 'depositVerified' },
    { label: 'Verified At', key: 'depositVerifiedAt' },
  ];

  // Quick preset filters
  const setPreset = (preset) => {
    const now = new Date();
    switch (preset) {
      case 'today':
        setStartDate(startOfDay(now));
        setEndDate(endOfDay(now));
        break;
      case 'thisWeek': {
        const day = now.getDay();
        const diffToMonday = day === 0 ? 6 : day - 1;
        const monday = new Date(now);
        monday.setDate(now.getDate() - diffToMonday);
        setStartDate(startOfDay(monday));
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        setEndDate(endOfDay(sunday));
        break;
      }
      case 'thisMonth': {
        const first = new Date(now.getFullYear(), now.getMonth(), 1);
        const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        setStartDate(startOfDay(first));
        setEndDate(endOfDay(last));
        break;
      }
      case 'thisYear': {
        const firstOfYear = new Date(now.getFullYear(), 0, 1);
        const lastOfYear = new Date(now.getFullYear(), 11, 31);
        setStartDate(startOfDay(firstOfYear));
        setEndDate(endOfDay(lastOfYear));
        break;
      }
      case 'financialYear': {
        let fyStart;
        let fyEnd;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
          fyEnd = new Date(now.getFullYear() + 1, 2, 31);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
          fyEnd = new Date(now.getFullYear(), 2, 31);
        }
        setStartDate(startOfDay(fyStart));
        setEndDate(endOfDay(fyEnd));
        break;
      }
      default:
        // Clear
        setStartDate(null);
        setEndDate(null);
    }
  };
  // NEW: State variables for donation form
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [donationType, setDonationType] = useState('cash');
  const [upiTransactionId, setUpiTransactionId] = useState('');
  const [bankName, setBankName] = useState('');
  const [chequeNumber, setChequeNumber] = useState('');
  const [aadharCard, setAadharCard] = useState('');
  const [panCard, setPanCard] = useState('');

  // NEW: Handle donation form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const donationData = {
      userId: adminUser._id,
      name,
      phone,
      email,
      city,
      amount: Number(amount),
      note,
      donationType,
      upiTransactionId: donationType === 'upi' ? upiTransactionId : undefined,
      bankName: donationType === 'cheque' ? bankName : undefined,
      chequeNumber: donationType === 'cheque' ? chequeNumber : undefined,
      aadharCard,
      panCard
    };

    try {
      await submitCashDonation(donationData);
      alert('Donation submitted successfully!');
      // Reset form and refresh data
      setName('');
      setPhone('');
      setEmail('');
      setCity('');
      setAmount('');
      setNote('');
      setDonationType('cash');
      setUpiTransactionId('');
      setBankName('');
      setChequeNumber('');
      setAadharCard('');
      setPanCard('');
      fetchCashDonations();
    } catch (error) {
      alert('Error submitting donation. Please try again.');
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Cash/Cheque/UPI Donations</h2>      {/* NEW: Donation Submission Form */}
      <form onSubmit={handleSubmit} className="mb-6 p-4 bg-white rounded shadow">
        <h3 className="text-xl font-semibold mb-4">Submit Cash Donation</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <label className="mb-1">Donor Name:</label>
            <input
              type="text"
              placeholder="Enter donor name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="border p-2 rounded"
            />
          </div>
          <div className="flex flex-col">
            <label className="mb-1">Phone Number:</label>
            <input
              type="text"
              placeholder="Enter phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              className="border p-2 rounded"
            />
          </div>
          <div className="flex flex-col">
            <label className="mb-1">Email:</label>
            <input
              type="email"
              placeholder="Enter email (optional)"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border p-2 rounded"
            />
          </div>
          <div className="flex flex-col">
            <label className="mb-1">City:</label>
            <input
              type="text"
              placeholder="Enter city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="border p-2 rounded"
            />
          </div>
          <div className="flex flex-col">
            <label className="mb-1">Amount (INR):</label>
            <input
              type="number"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
              className="border p-2 rounded"
            />
          </div>
          <div className="flex flex-col">
            <label className="mb-1">Donation Type:</label>
            <select
              value={donationType}
              onChange={(e) => setDonationType(e.target.value)}
              className="border p-2 rounded"
            >
              <option value="cash">Cash</option>
              <option value="cheque">Cheque</option>
              <option value="upi">UPI</option>
            </select>
          </div>
          
          {donationType === 'cheque' && (
            <>
              <div className="flex flex-col">
                <label className="mb-1">Bank Name:</label>
                <input
                  type="text"
                  placeholder="Enter bank name"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                  className="border p-2 rounded"
                />
              </div>
              <div className="flex flex-col">
                <label className="mb-1">Cheque Number:</label>
                <input
                  type="text"
                  placeholder="Enter cheque number"
                  value={chequeNumber}
                  onChange={(e) => setChequeNumber(e.target.value)}
                  className="border p-2 rounded"
                />
              </div>
            </>
          )}
          
          {donationType === 'upi' && (
            <div className="flex flex-col">
              <label className="mb-1">UPI Transaction ID:</label>
              <input
                type="text"
                placeholder="Enter UPI Transaction ID"
                value={upiTransactionId}
                onChange={(e) => setUpiTransactionId(e.target.value)}
                className="border p-2 rounded"
              />
            </div>
          )}
          
          <div className="flex flex-col">
            <label className="mb-1">Aadhar Card:</label>
            <input
              type="text"
              placeholder="Enter Aadhar number (optional)"
              value={aadharCard}
              onChange={(e) => setAadharCard(e.target.value)}
              className="border p-2 rounded"
            />
          </div>
          
          <div className="flex flex-col">
            <label className="mb-1">PAN Card:</label>
            <input
              type="text"
              placeholder="Enter PAN number (optional)"
              value={panCard}
              onChange={(e) => setPanCard(e.target.value)}
              className="border p-2 rounded"
            />
          </div>
          
          <div className="flex flex-col">
            <label className="mb-1">Note:</label>
            <textarea
              placeholder="Enter any note (optional)"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="border p-2 rounded"
            />
          </div>
        </div>
        <button
          type="submit"
          className="mt-4 bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark"
        >
          Submit Donation
        </button>
      </form>

      {/* Overall Summaries */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="p-6 bg-white rounded shadow">
          <h3 className="text-xl font-semibold">Cash</h3>
          <p>Transactions: {donationsCash.length}</p>
          <p>Total Amount: ₹{totalCash}</p>
        </div>
        <div className="p-6 bg-white rounded shadow">
          <h3 className="text-xl font-semibold">Cheque</h3>
          <p>Transactions: {donationsCheque.length}</p>
          <p>Total Amount: ₹{totalCheque}</p>
        </div>
        <div className="p-6 bg-white rounded shadow">
          <h3 className="text-xl font-semibold">UPI</h3>
          <p>Transactions: {donationsUPI.length}</p>
          <p>Total Amount: ₹{totalUPI}</p>
        </div>
      </div>

      {/* Trend Chart */}
      <div className="bg-white p-6 rounded shadow mb-6">
        <h3 className="text-xl font-semibold mb-4">Donation Trends (Last 7 Days)</h3>
        {chartData.labels && chartData.labels.length > 0 ? (
          <div className="h-64">
            <Line
              data={chartData}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          </div>
        ) : (
          <p>No trend data available.</p>
        )}
      </div>

      {/* Filter Controls */}
      <div className="mb-4 flex flex-wrap items-center gap-4">

        {/* Deposit Verified Filter */}
        <div className="flex flex-col">
          <label className="mb-1 font-semibold">Deposit Verified:</label>
          <select
            value={filterDepositVerified}
            onChange={e => setFilterDepositVerified(e.target.value)}
            className="border p-1 rounded"
          >
            <option value="">All</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>

        {/* Volunteer Dropdown */}
        <div className="flex flex-col">
          <label className="mb-1">Filter by Volunteer:</label>
          <select
            value={selectedVolunteerId}
            onChange={e => setSelectedVolunteerId(e.target.value)}
            className="border p-1 rounded"
          >
            <option value="">All Volunteers</option>
            {volunteers.map(vol => (
              <option key={vol._id} value={vol._id}>
                {vol.username}
              </option>
            ))}
          </select>
        </div>

        {/* Name (text) Filter */}
        <div className="flex flex-col">
          <label className="mb-1">Volunteer Name (text):</label>
          <input
            type="text"
            value={volunteerNameFilter}
            onChange={e => setVolunteerNameFilter(e.target.value)}
            placeholder="Search volunteer..."
            className="border p-1 rounded"
          />
        </div>

        {/* Date Range */}
        <div className="flex flex-col">
          <label className="mb-1">Start Date:</label>
          <DatePicker
            selected={startDate}
            onChange={date => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select start date"
            className="border p-1 rounded"
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-1">End Date:</label>
          <DatePicker
            selected={endDate}
            onChange={date => setEndDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select end date"
            className="border p-1 rounded"
          />
        </div>

        {/* Quick Preset Buttons */}
        <div className="flex flex-wrap gap-1">
          <button
            onClick={() => setPreset('today')}
            className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
          >
            Today
          </button>
          <button
            onClick={() => setPreset('thisWeek')}
            className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
          >
            This Week
          </button>
          <button
            onClick={() => setPreset('thisMonth')}
            className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
          >
            This Month
          </button>
          <button
            onClick={() => setPreset('thisYear')}
            className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
          >
            This Year
          </button>
          <button
            onClick={() => setPreset('financialYear')}
            className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
          >
            Fin. Year
          </button>
          <button
            onClick={() => setPreset(null)}
            className="bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
          >
            Clear
          </button>
        </div>

        {/* CSV Export */}
        <div className="flex flex-col justify-end">
          <CSVLink
            data={filteredDonations}
            headers={csvHeaders}
            filename={`cash-cheque-donations-${Date.now()}.csv`}
            className="px-4 py-2 bg-primary text-white rounded"
          >
            Export CSV
          </CSVLink>
        </div>
      </div>

      {/* Data Table */}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <DataTable
            columns={columns}
            data={filteredDonations}
            pagination
            defaultSortField="createdAt"
            responsive
            customStyles={customStyles}
            expandableRows
            expandableRowsComponent={ExpandedRow}
            conditionalRowStyles={conditionalRowStyles}
          />

          {/* Summation of filtered donations */}
          <div className="mt-4 p-4 bg-white rounded shadow">
            <h3 className="text-lg font-bold mb-2">Filtered Summary</h3>
            <p>Total Filtered Amount: <strong>₹{totalFilteredAmount}</strong></p>
            <p>Deposited (Acknowledged): <strong>₹{totalFilteredDeposited}</strong></p>
            <p>Pending Deposit: <strong>₹{totalFilteredPending}</strong></p>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminCashDonations;
